import TasksInfo from './TasksInfo';

export default TasksInfo;
